import { useEffect } from 'react';
import { FlexColumn } from '@elementary/common-ui/components';
import { UseFormReturn } from 'react-hook-form';
import {
  getTimeBucketUnitOptions,
  trainingPeriodOptions,
} from 'shared/constants';
import useSelectedWarehouseType from 'shared/hooks/useSelectedWarehouseType';
import { AddTestForm } from 'shared/types';
import { getAnomalyTimeWindowError } from 'shared/utils/anomalyTimeWindow';
import PeriodCountField from './PeriodCountField';

type Props = {
  methods: UseFormReturn<AddTestForm, any, undefined>;
  timeBucketDisabledReason?: string;
};

const AnomalyTimeWindowFields = ({
  methods,
  timeBucketDisabledReason,
}: Props) => {
  const warehouseType = useSelectedWarehouseType();
  const { watch, trigger } = methods;
  const detectionPeriod = watch('detectionPeriod');
  const detectionUnit = watch('detectionUnit');
  const trainingPeriodUnit = watch('trainingPeriodUnit');
  const seasonality = watch('seasonality');

  useEffect(() => {
    trigger('trainingPeriodCount');
  }, [
    detectionPeriod,
    detectionUnit,
    trainingPeriodUnit,
    seasonality,
    timeBucketDisabledReason,
    trigger,
  ]);

  return (
    <FlexColumn sx={{ gap: 1.5 }}>
      <PeriodCountField
        methods={methods}
        title="Time bucket:"
        prefix="every"
        countName="detectionPeriod"
        unitName="detectionUnit"
        unitOptions={getTimeBucketUnitOptions(warehouseType)}
        countAriaLabel="Time bucket count"
        unitAriaLabel="Time bucket unit"
        disabledReason={timeBucketDisabledReason}
      />
      <PeriodCountField
        methods={methods}
        title="Compare to:"
        prefix="the last"
        countName="trainingPeriodCount"
        unitName="trainingPeriodUnit"
        unitOptions={trainingPeriodOptions}
        validate={(values) =>
          timeBucketDisabledReason
            ? true
            : getAnomalyTimeWindowError(values) ?? true
        }
        countAriaLabel="Comparison window count"
        unitAriaLabel="Comparison window unit"
      />
    </FlexColumn>
  );
};

export default AnomalyTimeWindowFields;
